import React from 'react';

const RatingComponent = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center sm:gap-3 gap-1">
      {/* Green Rating Stars */}
      <div className="flex items-center gap-0.5 sm:gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star} className="text-green-500 text-base sm:text-lg">
            ★
          </span>
        ))}
      </div>
      
      {/* Rating Text */}
      <div className="text-gray-700 text-xs sm:text-sm font-medium text-center sm:text-left">
        Rated 4.9 by 10k+ Users
      </div>
    </div>
  );
};

export default RatingComponent;